"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignInButtonStyles = exports.ListStyles = exports.ListItemStyles = exports.HeadingStyles = exports.FragmentStyles = exports.DrawerStyles = exports.DrawerPaperStyles = exports.DividerStyles = exports.ButtonStyles = exports.BackButtonStyles = void 0;
var Styles = _interopRequireWildcard(require("./MenuDrawerStyles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  inverseRegEx = /^inverse/,
  BackButtonStyles = theme => {
    return merge(Styles.ButtonStyles(theme), {
      alignItems: "center",
      backgroundColor: theme.mixins.navigation.mobile.backButtonBackgroundColor,
      color: theme.mixins.navigation.mobile.backButtonColor,
      display: "flex",
      fontFamily: theme.fontFamilies.bold,
      justifyContent: "flex-start",
      padding: "2.1rem",
      "@media(hover:none)": {
        "&:hover": {
          backgroundColor: theme.mixins.navigation.mobile.backButtonBackgroundColor,
          color: theme.mixins.navigation.mobile.backButtonColor,
          textDecoration: "unset"
        }
      },
      "@media(hover:hover)": {
        "&:hover": {
          backgroundColor: `${theme.mixins.navigation.mobile.backButtonBackgroundColorHover} !important`,
          color: `${theme.mixins.navigation.mobile.backButtonColorHover} !important`,
          textDecoration: "underline"
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: `${theme.mixins.navigation.mobile.backButtonBackgroundColorHover} !important`,
        color: `${theme.mixins.navigation.mobile.backButtonColorHover} !important`,
        textDecoration: "underline"
      },
      "&::before": {
        backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/icons/icon_chevron--darkest-blue.svg")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        content: "''",
        display: "inline-block",
        height: "1.5rem",
        marginRight: "1.4rem",
        transform: "rotate(180deg)",
        width: "0.9rem"
      },
      "&::after": {
        display: "none"
      }
    });
  },
  ButtonStyles = function (theme) {
    let variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
    const isInverse = inverseRegEx.test(variant);
    return {
      borderRadius: "0",
      color: isInverse ? theme.mixins.navigation.mobile.linkColorInverse : theme.mixins.navigation.mobile.linkColor,
      display: "block",
      fontFamily: theme.fontFamilies.semiBold,
      fontSize: "1.6rem",
      fontWeight: "normal",
      lineHeight: "1.4",
      padding: "1.6rem 7rem 1.6rem 2.1rem",
      position: "relative",
      textAlign: "left",
      textDecoration: "none",
      textTransform: "none",
      width: "100%",
      "@media(hover:hover)": {
        "&:hover": {
          color: isInverse ? theme.mixins.navigation.mobile.linkColorHoverInverse : theme.mixins.navigation.mobile.linkColorHover,
          textDecoration: "underline"
        }
      },
      "&.navigation-mobile__drawer-button": {
        "@media(hover:none)": {
          "&:hover": {
            backgroundColor: "transparent",
            textDecoration: "unset"
          }
        },
        "@media(hover:hover)": {
          "&:hover": {
            backgroundColor: isInverse ? theme.mixins.navigation.mobile.drawerButtonBackgroundColorHoverInverse : theme.mixins.navigation.mobile.drawerButtonBackgroundColorHover,
            textDecoration: "underline"
          }
        },
        "&:active,&:focus-visible": {
          backgroundColor: isInverse ? theme.mixins.navigation.mobile.drawerButtonBackgroundColorHoverInverse : theme.mixins.navigation.mobile.drawerButtonBackgroundColorHover,
          textDecoration: "underline"
        }
      },
      "&::after": {
        alignSelf: "stretch",
        backgroundImage: isInverse ? `url("${process.env.PUBLIC_URL}/general/images/icons/icon_chevron--blue.svg")` : `url("${process.env.PUBLIC_URL}/general/images/icons/icon_chevron--white.svg")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        content: "''",
        display: "inline-block",
        height: "1.5rem",
        position: "absolute",
        right: "3.3rem",
        top: "calc(50% - 0.75rem)",
        width: "0.9rem"
      }
    };
  },
  DividerStyles = (theme, variant) => {
    const isInverse = inverseRegEx.test(variant);
    return {
      borderColor: isInverse ? theme.mixins.navigation.mobile.dividerColorInverse : theme.mixins.navigation.mobile.dividerColor,
      borderWidth: "0 0 0.1rem",
      opacity: "0.37",
      margin: "1.4rem auto",
      width: "24rem"
    };
  },
  DrawerStyles = theme => {
    return {
      ".MuiModal-backdrop": {
        backgroundColor: theme.mixins.navigation.mobile.drawerModalBackgroundColor
      }
    };
  },
  DrawerPaperStyles = function (theme) {
    let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "block";
    let variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
    const isInverse = inverseRegEx.test(variant);
    return {
      backgroundColor: isInverse ? theme.mixins.navigation.mobile.drawerPaperBackgroundColorInverse : theme.mixins.navigation.mobile.drawerPaperBackgroundColor,
      backgroundImage: isInverse ? "none" : `url("${process.env.PUBLIC_URL}/general/images/footer/pheaa_cap.svg")`,
      backgroundPosition: "-25rem 40rem",
      backgroundRepeat: "no-repeat",
      color: isInverse ? theme.mixins.navigation.mobile.drawerPaperColorInverse : theme.mixins.navigation.mobile.drawerPaperColor,
      display: display,
      maxWidth: "32rem",
      overflowX: "hidden",
      overflowY: "auto",
      padding: "0 0 2rem 0",
      width: "32rem",
      "a.navigation-mobile__heading-anchor": {
        color: isInverse ? theme.mixins.navigation.mobile.linkColorInverse : theme.mixins.navigation.mobile.linkColor,
        "&:hover": {
          color: isInverse ? theme.mixins.navigation.mobile.linkColorHoverInverse : theme.mixins.navigation.mobile.linkColorHover,
          fontWeight: "inherit",
          textDecoration: "underline"
        }
      },
      "a.navigation-mobile__drawer-link": merge(Styles.ButtonStyles(theme), {
        color: isInverse ? theme.mixins.navigation.mobile.linkColorInverse : theme.mixins.navigation.mobile.linkColor,
        fontFamily: theme.fontFamilies.semiBold,
        fontWeight: "normal",
        padding: "1rem 2.1rem",
        "@media(hover:hover)": {
          "&:hover": {
            backgroundColor: isInverse ? theme.mixins.navigation.mobile.drawerButtonBackgroundColorHoverInverse : theme.mixins.navigation.mobile.drawerButtonBackgroundColorHover,
            color: isInverse ? theme.mixins.navigation.mobile.linkColorHoverInverse : theme.mixins.navigation.mobile.linkColorHover,
            textDecoration: "underline"
          }
        },
        "&::after": {
          display: "none"
        }
      }),
      ".navigation-mobile__new-indicator": {
        backgroundColor: theme.mixins.navigation.mobile.indicatorBackgroundColor,
        color: theme.mixins.navigation.mobile.indicatorColor,
        display: "inline-block",
        marginLeft: "0.4em",
        padding: "0.3rem 0.5rem 0.3rem 0.3rem",
        textTransform: "uppercase"
      }
    };
  },
  FragmentStyles = function (theme) {
    let variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
    const isInverse = inverseRegEx.test(variant);
    return {
      fontSize: "1.6rem",
      ".navigation-mobile__back-button + &": {
        marginTop: "2rem"
      },
      "ul": merge(Styles.ListStyles(theme), {
        "ul": {
          paddingLeft: "2rem",
          "+ ul": {
            marginTop: "2rem"
          },
          "li": {
            fontSize: "1.4rem"
          }
        }
      }),
      "li": merge(Styles.ListItemStyles(theme), {
        "> a, > strong > a": merge(Styles.ButtonStyles(theme), {
          color: isInverse ? theme.mixins.navigation.mobile.linkColorInverse : theme.mixins.navigation.mobile.linkColor,
          fontFamily: theme.fontFamilies.default,
          fontWeight: "normal",
          padding: "1rem 2.1rem",
          "@media(hover:hover)": {
            "&:hover": {
              backgroundColor: isInverse ? theme.mixins.navigation.mobile.linkBackgroundColorHoverInverse : theme.mixins.navigation.mobile.linkBackgroundColorHover,
              color: isInverse ? theme.mixins.navigation.mobile.linkColorHoverInverse : theme.mixins.navigation.mobile.linkColorHover,
              textDecoration: "underline"
            }
          },
          "&:active,&:focus-visible": {
            backgroundColor: isInverse ? theme.mixins.navigation.mobile.linkBackgroundColorHoverInverse : theme.mixins.navigation.mobile.linkBackgroundColorHover,
            color: isInverse ? theme.mixins.navigation.mobile.linkColorHoverInverse : theme.mixins.navigation.mobile.linkColorHover,
            textDecoration: "underline"
          },
          "&::after": {
            display: "none"
          }
        }),
        "> strong > a": {
          fontFamily: theme.fontFamilies.bold,
          marginTop: "1.4rem",
          textDecoration: "underline"
        }
      })
    };
  },
  HeadingStyles = theme => {
    return {
      display: "flex",
      flexDirection: "column",
      fontFamily: theme.fontFamilies.semiBold,
      fontWeight: "normal",
      margin: "1rem 0 0",
      padding: "1rem 2.1rem",
      "&::after": {
        backgroundColor: theme.mixins.navigation.mobile.headingUnderline,
        content: "''",
        display: "block",
        height: "0.3rem",
        margin: "0.8rem 0 0",
        width: "4.5rem"
      }
    };
  },
  ListStyles = () => {
    return {
      display: "block",
      fontSize: "inherit",
      margin: "0",
      padding: "0"
    };
  },
  ListItemStyles = () => {
    return {
      display: "block",
      fontSize: "inherit",
      margin: "0",
      padding: "0"
    };
  },
  SignInButtonStyles = theme => {
    return merge(Styles.ButtonStyles(theme), {
      backgroundColor: theme.mixins.navigation.mobile.signInLinkBackgroundColor,
      color: theme.mixins.navigation.mobile.signInLinkColor,
      display: "flex",
      justifyContent: "flex-start",
      "@media(hover:none)": {
        "&:hover": {
          backgroundColor: `${theme.mixins.navigation.mobile.signInLinkBackgroundColor} !important`,
          color: `${theme.mixins.navigation.mobile.signInLinkColor} !important`,
          textDecoration: "unset"
        }
      },
      "@media(hover:hover)": {
        "&:hover": {
          backgroundColor: `${theme.mixins.navigation.mobile.signInLinkBackgroundColorHover} !important`,
          color: `${theme.mixins.navigation.mobile.signInLinkColorHover} !important`,
          textDecoration: "underline"
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: `${theme.mixins.navigation.mobile.signInLinkBackgroundColorHover} !important`,
        color: `${theme.mixins.navigation.mobile.signInLinkColorHover} !important`,
        textDecoration: "underline"
      },
      "&::before": {
        backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/icons/icon-login.svg")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "3rem 2.5rem",
        content: "''",
        display: "inline-block",
        height: "2.5rem",
        margin: "0 1rem 0 0",
        width: "3rem"
      }
    });
  };
exports.SignInButtonStyles = SignInButtonStyles;
exports.ListItemStyles = ListItemStyles;
exports.ListStyles = ListStyles;
exports.HeadingStyles = HeadingStyles;
exports.FragmentStyles = FragmentStyles;
exports.DrawerPaperStyles = DrawerPaperStyles;
exports.DrawerStyles = DrawerStyles;
exports.DividerStyles = DividerStyles;
exports.ButtonStyles = ButtonStyles;
exports.BackButtonStyles = BackButtonStyles;